import React from 'react';
import PropTypes from 'prop-types';

import { Container, Image } from './styles';

function AiEnding({ data, isBuilder }) {
  return (
    <Container isBuilder={isBuilder}>
      <Image src={data.image} />
    </Container>
  );
}

AiEnding.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.string,
    prompt: PropTypes.string,
    promptId: PropTypes.string,
  }),
  isBuilder: PropTypes.bool,
};

AiEnding.defaultProps = {
  data: {
    image:
      'https://overlayon.s3.eu-west-3.amazonaws.com/replicate-1729074838562',
    prompt:
      'An ultramodern cityscape at night with neon lights and holograms, featuring "Starting Soon" in glowing neon letters across the sky.',
    promptId: 'cyberpunk',
  },
  isBuilder: false,
};

export default AiEnding;
